import {defineAsyncComponent} from 'vue';

export {Splide, SplideSlide, SplideTrack} from '@splidejs/vue-splide';
export {default as AnnouncementBar} from './AnnouncementBar.vue';
export {default as VIcon} from './VIcon.vue';
export {default as VImage} from './VImage.vue';
export {default as VModal} from './VModal.vue';

export const CartDrawerHeader = defineAsyncComponent(() => import('./CartDrawerHeader.vue'));
export const CartDrawerCongratulations = defineAsyncComponent(() =>
  import('./CartDrawerCongratulations.vue')
);
export const CartDrawerProgressBar = defineAsyncComponent(() =>
  import('./CartDrawerProgressBar.vue')
);
export const CartDrawerProducts = defineAsyncComponent(() => import('./CartDrawerProducts.vue'));
export const CartDrawerSummary = defineAsyncComponent(() => import('./CartDrawerSummary.vue'));
export const CartDrawerCheckoutButton = defineAsyncComponent(() =>
  import('./CartDrawerCheckoutButton.vue')
);
export const CartDrawerPaymentIcons = defineAsyncComponent(() =>
  import('./CartDrawerPaymentIcons.vue')
);
export const CartDrawerDiscountBanner = defineAsyncComponent(() =>
  import('./CartDrawerDiscountBanner.vue')
);
export const CartDrawerDivider = defineAsyncComponent(() => import('./CartDrawerDivider.vue'));
export const CartDrawerUpsellItem = defineAsyncComponent(() =>
  import('./CartDrawerUpsellItem.vue')
);
export const GridItemTags = defineAsyncComponent(() => import('./GridItemTags.vue'));
export const CartCountBadge = defineAsyncComponent(() => import('./CartCountBadge.vue'));
export const CartDrawer = defineAsyncComponent(() => import('./CartDrawer.vue'));
export const MobileMenuWrapper = defineAsyncComponent(() => import('./MobileMenuWrapper.vue'));
export const SearchBar = defineAsyncComponent(() => import('./SearchBar.vue'));
export const StorePicker = defineAsyncComponent(() => import('./StorePicker.vue'));
export const VAccordion = defineAsyncComponent(() => import('./VAccordion.vue'));
export const VGrid = defineAsyncComponent(() => import('./VGrid.vue'));
export const VVideo = defineAsyncComponent(() => import('./VVideo.vue'));
export const VCounter = defineAsyncComponent(() => import('./VCounter.vue'));
export const FeaturedCollection = defineAsyncComponent(() => import('./FeaturedCollection.vue'));
export const GeoPopup = defineAsyncComponent(() => import('./GeoPopup.vue'));
export const CustomDiscounts = defineAsyncComponent(() => import('./CustomDiscounts.vue'));
export const LogoSlider = defineAsyncComponent(() => import('./LogoSlider.vue'));
export const MegaMenu = defineAsyncComponent(() => import('./MegaMenu.vue'));
export const RegisterNoteInputs = defineAsyncComponent(() => import('./RegisterNoteInputs.vue'));
